import styled from "styled-components";
import { Form, FormGroup, Input, Label } from "reactstrap";

export const PathwayCheckBoxFormGroup = styled(FormGroup)`
    display: grid;
    grid-template-columns: 0.1fr 0.9fr;
    align-items: center;
    justify-items: start;
    column-gap: var(--gap-s);
    margin: 0 !important;

    & > input {
        margin: unset;
        position: unset;
        height: 1rem;
    }

    & > label {
        margin-bottom: 0 !important;
    }
`;

export const PathwayFormGroup = styled(FormGroup)`
    display: grid;
    row-gap: var(--gap-s);

    align-items: center;
    justify-items: start;
    margin: 0 !important;

    & > input {
        margin: unset;
    }

    & > label {
        margin-bottom: 0 !important;
    }
`;

//used for Forms with validation of <PathwayTextInputGroup>
export const PathwayFormGrid = styled.div`
    display: grid;
    row-gap: var(--gap-xl);
`;

//used for Forms without validation of <PathwayTextInputGroup>
export const PathwayFormGridSmall = styled.div`
    display: grid;
    row-gap: var(--gap-m);
`;

export const PathwayCheckbox = styled(Input)`
    margin: unset;
    position: unset;
`;

export const PathwayLabel = styled(Label)`
    margin: 0;
`;

export const AlineLabelWithExtra = styled.div`
    display: grid;
    grid-template-columns: min-content min-content;
`;

export const PathwayForm = styled(Form)`
    display: grid;
    column-gap: 1em;
    row-gap: 1em;
`;

export const PathwayCheckBoxFormGroupEndAligned = styled(PathwayCheckBoxFormGroup)`
    grid-template-columns: min-content max-content;
`;

export const PathwayFormGroupAligned = styled(FormGroup)`
    margin: 0;
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    align-items: center;
    justify-items: start;
    column-gap: 0.25rem;
`;
